import BottomCTA from "@/components/BottomCTA/BottomCTA";
import Container from "@/components/Container/Container";
import FeatureSection from "@/components/FeatureSection/FeatureSection";
import Layout from "@/components/Layout/Layout";
import Testimonials from "@/components/Testimonial/Testimonials";
import {
  Heading,
  H5Css,
  H2Css,
  Body,
  BodyRegular14Css,
  BodyMedium20Css,
} from "@/components/Typography";
import { mq } from "@/constants/breakpoints";
import { css } from "@emotion/react";
import Balancer from "react-wrap-balancer";
import buildFormsImage from "../../../public/images/features/online-registration/build-forms.png";
import collectPaymentsDesktopImage from "../../../public/images/features/online-registration/collect-payments-desktop.png";
import collectPaymentsMobileImage from "../../../public/images/features/online-registration/collect-payments-mobile.png";
import manageRegistrationImage from "../../../public/images/features/online-registration/manage-registered-players.png";
import { darkColor } from "@/constants/colors";
import MoreFeaturesSection from "@/components/FeatureSection/MoreFeaturesSection";
import exportSpreadsheetImage from "../../../public/images/features/online-registration/export-spreadsheet.svg";
import organizeTeamRegistrationsImage from "../../../public/images/features/online-registration/organize-team-registrations.svg";
import donationsImage from "../../../public/images/features/online-registration/donations.svg";
import waiverAcknowledgementsImage from "../../../public/images/features/online-registration/waiver-acknowledgements.svg";
import { useEffect, useState } from "react";
import Script from "next/script";
import PlayButton from "@/svg/PlayButton";
import GetStartedButton from "@/components/Buttons/GetStartedButton";
import { getFeaturePage } from "@/utils/getFeaturePage";
import PageFAQSection from "@/components/PageFAQSection";
import HeroImage from "@/components/HeroImage";

const WISTIA_ID = "qhqhtci0ae";

const Page = ({ fields }: any) => {
  const [video, setVideo] = useState<any>(null);

  useEffect(() => {
    // @ts-ignore
    window._wq = window._wq || [];
    // @ts-ignore
    window._wq.push({
      id: WISTIA_ID,
      onReady: function (returnVideo: any) {
        setVideo(returnVideo);
      },
    });
  }, []);

  const handleClick = () => {
    try {
      video.popover.show();
      video.play();
      // const event = 'Played Explainer Video';
      // window.heap?.track(event);
    } catch (e) {
      console.log(e);
      // Sentry.captureException(e);
    }
  };

  return (
    <>
      <Script
        src="https://fast.wistia.com/assets/external/E-v1.js"
        strategy="lazyOnload"
      />
      <Layout
        title={fields.pageTitle}
        metaDescription={fields.metaDescription}
        heroContainerCss={css`
          background: url(/images/features/online-registration/BG.svg), #aef2ea;
          background-size: cover;
          background-repeat: no-repeat;
        `}
        hero={
          <Container>
            <div
              css={css`
                text-align: center;
                margin-top: 22px;
                color: #fff;
                display: flex;
                flex-direction: column;
                ${mq["lg"]} {
                  margin-top: 70px;
                  flex-direction: row;
                }
              `}
            >
              <div
                css={css`
                  ${mq["lg"]} {
                    flex: 1.5;
                    margin-top: 40px;
                  }
                `}
              >
                <Heading
                  level={1}
                  css={css`
                    ${H5Css}
                    color: ${darkColor};
                    ${mq["lg"]} {
                      ${H2Css}
                      text-align: left;
                    }
                  `}
                >
                  <Balancer>{fields.heroTitle}</Balancer>
                </Heading>
                <Body
                  css={css`
                    margin-top: 14px;
                    color: ${darkColor};
                    ${BodyRegular14Css}
                    ${mq["lg"]} {
                      text-align: left;
                      margin-top: 24px;
                      ${BodyMedium20Css}
                    }
                  `}
                >
                  <Balancer>{fields.heroSubtitle}</Balancer>
                </Body>
                <div
                  css={css`
                    width: fit-content;
                    display: block;
                    margin: auto;
                    ${mq["lg"]} {
                      margin: unset;
                    }
                  `}
                >
                  <div
                    css={css`
                      margin: 28px auto 0;
                      ${mq["lg"]} {
                        margin: 40px 0 0;
                      }
                    `}
                  >
                    <GetStartedButton />
                  </div>
                </div>
              </div>
              <div
                css={css`
                  margin-top: 50px;
                  flex: 1;
                  position: relative;
                  ${mq["xs"]} {
                    margin-left: -16px;
                    margin-right: -16px;
                  }

                  ${mq["lg"]} {
                    margin-top: 0;
                    height: 502px;
                  }
                `}
              >
                <div
                  css={css`
                    ${mq["xs"]} {
                      display: flex;
                      width: 100%;
                    }
                    ${mq["sm"]} {
                      display: unset;
                      width: unset;
                    }
                    & img {
                      height: auto;
                      width: 100%;
                      max-width: 100%;

                      ${mq["lg"]} {
                        max-width: unset;
                        padding-top: 0;
                        width: auto;
                        height: 552px;
                        right: -40px;
                        top: -50px;
                        position: absolute;
                      }
                      ${mq["xl"]} {
                        right: calc(-1 * ((100vw - 1192px - 40px) / 2));
                      }
                    }
                  `}
                >
                  <HeroImage
                    images={{
                      xs: fields.heroImageXs.url,
                      sm: fields.heroImageSm.url,
                      md: fields.heroImageMd.url,
                      lg: fields.heroImageLg.url,
                      xl: fields.heroImageXl.url,
                      xl2: fields.heroImageXl2.url,
                    }}
                    alt="Youth Sports Registration Software"
                  />
                </div>
                {video && (
                  <PlayButton
                    onClick={handleClick}
                    role="button"
                    css={css`
                      position: absolute;
                      left: 0;
                      right: 0;
                      top: 0;
                      bottom: 0;
                      margin: auto;
                      ${mq["lg"]} {
                        left: 150px;
                      }
                    `}
                  />
                )}
              </div>
            </div>
          </Container>
        }
      >
        {fields.sectionsCollection.items.map((section: any, index: number) => {
          let desktopImage;
          let mobileImage;
          switch (index) {
            case 0:
              desktopImage = buildFormsImage;
              break;
            case 1:
              desktopImage = collectPaymentsDesktopImage;
              mobileImage = collectPaymentsMobileImage;
              break;
            case 2:
              desktopImage = manageRegistrationImage;
          }
          return (
            <FeatureSection
              key={index}
              imageFirst={index % 2 === 1}
              desktopImage={desktopImage}
              mobileImage={mobileImage}
              sectionHeadline={section.sectionTitle}
              feat1Headline={section.item1Title}
              feat1Body={section.item1Description}
              feat2Headline={section.item2Title}
              feat2Body={section.item2Description}
              feat3Headline={section.item3Title}
              feat3Body={section.item3Description}
              feat4Headline={section.item4Title}
              feat4Body={section.item4Description}
              sectionSEOText={
                index === 0 ? "Sports League Registration Software" : undefined
              }
            />
          );
        })}
        <div
          css={css`
            margin-top: 60px;
          `}
        />
        <MoreFeaturesSection
          headline={fields.summaryHeading}
          tlHeadline={fields.summaryItemsCollection.items[0].heading}
          tlBody={fields.summaryItemsCollection.items[0].description}
          tlIcon={exportSpreadsheetImage}
          trHeadline={fields.summaryItemsCollection.items[1].heading}
          trBody={fields.summaryItemsCollection.items[1].description}
          trIcon={organizeTeamRegistrationsImage}
          blHeadline={fields.summaryItemsCollection.items[2].heading}
          blBody={fields.summaryItemsCollection.items[2].description}
          blIcon={waiverAcknowledgementsImage}
          brHeadline={fields.summaryItemsCollection.items[3].heading}
          brBody={fields.summaryItemsCollection.items[3].description}
          brIcon={donationsImage}
        />
        <Testimonials testimonials={fields.testimonialsCollection.items} />
        <div
          css={css`
            margin-top: 60px;
          `}
        >
          <BottomCTA />
        </div>
        {fields?.faqSection?.questionsAndAnswersCollection?.items.length >
          0 && (
          <div
            css={css`
              margin-top: 60px;
              ${mq["lg"]} {
                margin-top: 120px;
                margin-bottom: 120px;
              }
            `}
          >
            <PageFAQSection
              faqItems={
                fields?.faqSection?.questionsAndAnswersCollection?.items || []
              }
            />
          </div>
        )}
      </Layout>
      <div
        className={`wistia_embed wistia_async_${WISTIA_ID} popover=true stillUrl=data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=`}
        style={{ position: "relative", width: 0, height: 0 }}
      />
    </>
  );
};

export const getStaticProps = async () => {
  const { fields } = await getFeaturePage("Registration");

  return { props: { fields } };
};

export default Page;
